import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import { removeCss } from '@shared/easyfy.utils';

namespace Easyfy.Components {
  @invoke
  class TableOfContentComponent {
    constructor() {}

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          event: 'show-all-tableofcontent',
          callback: TableOfContentComponent.showAll
        }
      });
    }

    static showAll(e) {
      const target: HTMLElement = e.target as HTMLElement;
          const tableOfContent: HTMLElement = target?.parentElement;
          if (tableOfContent) removeCss(tableOfContent, 'collapsed');
    }
  }
}
